import { createSelector } from 'reselect';
import { selectUser } from './authenticationSelectors';
import { itemsListConstants } from '../../../adapters/primary/ui/enoapp/components/AppDrawer/drawer-config';

const selectRoute = (state) => state.route;

const selectCrumbs = createSelector(selectRoute, (route) => route.crumbs);

const selectRoutes = createSelector(selectRoute, (route) => route.routes);

export const selectShowProducersMenu = createSelector(
    selectUser,
    selectCrumbs,
    (user, items) =>
        user.role === 'participant' &&
        items.some((item) =>
            [
                itemsListConstants().INVOICES.label,
                itemsListConstants().BILLING_SUBSCRIPTIONS.label,
                itemsListConstants().PAYMENT_CONFIG.label,
            ].includes(item.label)
        )
);
export { selectCrumbs, selectRoutes };
